import { Plugin } from "ckeditor5";

import { EditorVariant } from "../types";

type BaseAnalyticsEvent = {
  action: "Open Wiris Editor";
  from: "Toolbar" | "Existing Equation";
  type: "MathType" | "ChemType";
};

type DefaultAnalyticsProperties = {
  variant?: EditorVariant;
};

export type AnalyticsEvent = BaseAnalyticsEvent & DefaultAnalyticsProperties;

export default class Analytics extends Plugin {
  private defaultProperties: DefaultAnalyticsProperties | undefined;
  private onEvent: ((event: AnalyticsEvent) => void) | undefined;

  init() {
    this.onEvent = this.editor.config.get("analytics.onEvent");
  }

  afterInit() {
    if (this.onEvent == null) return;

    this.editor.commands.get("MathType")?.on("execute", () => {
      this.trackEventInternal({
        action: "Open Wiris Editor",
        from: "Toolbar",
        type: "MathType",
      });
    });

    this.editor.commands.get("ChemType")?.on("execute", () => {
      this.trackEventInternal({
        action: "Open Wiris Editor",
        from: "Toolbar",
        type: "ChemType",
      });
    });
  }

  setDefaultProperties(properties: DefaultAnalyticsProperties) {
    this.defaultProperties = properties;
  }

  private trackEventInternal(event: BaseAnalyticsEvent) {
    try {
      this.onEvent?.({
        ...event,
        ...this.defaultProperties,
      });
    } catch (e) {
      console.error(`Error tracking analytics event`, e);
    }
  }
}

declare module "ckeditor5" {
  interface EditorConfig {
    analytics?: {
      onEvent?: (event: AnalyticsEvent) => void;
    };
  }
}
